import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1230051Status: 'idle',
    startProcess1230051Error: undefined as any,
    loadUserParamsProcess1230051Status: 'idle',
    loadUserParamsProcess1230051Error: undefined as any,

    process1230051List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1230051 = createAsyncThunk('process1230051Slice/startProcess1230051', async ({ process1230051 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1230051/`,
        prepareData(process1230051),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1230051Status } = getState().process1230051Slice
        return startProcess1230051Status !== 'pending'
    }
})

export const loadUserParamsProcess1230051 = createAsyncThunk('process1230051Slice/loadUserParamsProcess1230051', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1230051/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1230051Status } = getState().process1230051Slice
        return loadUserParamsProcess1230051Status !== 'pending'
    }
})

const Process1230051Slice = createSlice({
    name: 'process1230051Slice',
    initialState,
    reducers: {
        resetstartProcess1230051: (state) => {
            state.job = undefined
            state.startProcess1230051Error = undefined
        },
        resetstartProcess1230051Error: (state) => {
            state.startProcess1230051Error = undefined
        },
        resetloadUserParamsProcess1230051: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1230051Error = undefined
        },
        resetloadUserParamsProcess1230051Error: (state) => {
            state.loadUserParamsProcess1230051Error = undefined
        },
        removeFromProcess1230051ListById: (state, action) => {
            state.process1230051List = state.process1230051List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1230051ListByIds: (state, action) => {
            state.process1230051List = state.process1230051List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1230051List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1230051Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1230051List = []
            state.startProcess1230051Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1230051.pending, (state) => {
            state.startProcess1230051Status = 'pending'
            state.startProcess1230051Error = undefined
        })
        builder.addCase(startProcess1230051.fulfilled, (state, action) => {
            state.startProcess1230051Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1230051.rejected, (state, action) => {
            state.startProcess1230051Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1230051Error = action.error.message
            } else {
                state.startProcess1230051Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1230051.pending, (state) => {
            state.loadUserParamsProcess1230051Status = 'pending'
            state.loadUserParamsProcess1230051Error = undefined
        })
        builder.addCase(loadUserParamsProcess1230051.fulfilled, (state, action) => {
            state.loadUserParamsProcess1230051Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1230051.rejected, (state, action) => {
            state.loadUserParamsProcess1230051Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1230051Error = action.error.message
            } else {
                state.loadUserParamsProcess1230051Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1230051,
    resetstartProcess1230051Error,
    resetloadUserParamsProcess1230051,
    resetloadUserParamsProcess1230051Error,
    removeFromProcess1230051ListById,
    removeFromProcess1230051ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1230051Slice.actions
export default Process1230051Slice.reducer
